import clsx from 'clsx';
import { observer } from 'mobx-react';
import * as React from 'react';
import LoadingIndicator from '../../../LoadingIndicator';
import { T } from '../../../../Translations';
import ModalStore from '../../../Modal/Store';
import { LearningCollectionSummaryResource } from '../../Types';
import CloneStore from './Clone/Store';
import CollaboratorAccessStore from './CollaboratorAccess/Store';
import LearningCollectionListItemReady from './LearningCollectionListItemReady';
import LearningCollectionStore from './Store';

interface Props {
  shareModalStore: ModalStore;
  hideModalStore: ModalStore;
  cloneStore: CloneStore;
  collaboratorAccessStore: CollaboratorAccessStore;
  learningCollectionStore: LearningCollectionStore;
  learningCollectionSummaryResource: LearningCollectionSummaryResource;
}

const LearningCollectionListItemState: React.FC<Props> = ({
  learningCollectionSummaryResource,
  learningCollectionStore,
  hideModalStore,
  shareModalStore,
  cloneStore,
  collaboratorAccessStore,
}) => {
  return (
    <div className="relative mb-2">
      <LearningCollectionListItemReady
        shareModalStore={shareModalStore}
        hideModalStore={hideModalStore}
        cloneStore={cloneStore}
        collaboratorAccessStore={collaboratorAccessStore}
        learningCollectionStore={learningCollectionStore}
        learningCollectionSummaryResource={learningCollectionSummaryResource}
      />
      <div
        className={clsx(
          'absolute top-0 flex h-full w-full items-center',
          'justify-center bg-white opacity-80 text-xs',
        )}
      >
        <p>
          <T kind="Removing" />
        </p>
        <LoadingIndicator
          type="bubbles"
          color="black"
          height={64}
          width={64}
          delay={0}
          className=""
        />
      </div>
    </div>
  );
};

export default observer(LearningCollectionListItemState);
